<template>
	<div>
		<b-row class="float-right">
			<b-col>
				<b-button
					v-if="$hasPermission('serviceType.add')"
					@click="newModel"
					>Nuevo Servicio</b-button
				>
			</b-col>
		</b-row>

		<h2 v-if="!embbebedOnSupplier">Tipos de servicio</h2>
		<hr v-if="!embbebedOnSupplier" />
		<b-form
			@submit="
				evt => {
					evt.preventDefault();
					this.$root.$emit(
						'bv::refresh::table',
						'service-types-index-list'
					);
				}
			"
		>
			<div class="row">
				<b-form-group class="col-2" label="Buscar">
					<b-form-input v-model="filters.search" type="text" />
				</b-form-group>
				<b-form-group class="col-2" label=".">
					<b-button type="submit" variant="primary">Buscar</b-button>
				</b-form-group>
			</div>
		</b-form>
		<AjaxTable
			permission-show="serviceType.show"
			id="service-types-index-list"
			:filters="filters"
			responsive="md"
			:columns="modelColumns"
			resource="service-types"
		>

			<template v-slot:cell(actions)="row">
				<div class="text-center">
					<b-button
						@click="event => editModel(row.item.id)"
						type="button"
						size="sm"
						class="mr-1"
						variant="info"
					>
						<md-icon icon="edit" />
					</b-button>
					<b-button
						v-if="$hasPermission('serviceType.delete')"
						@click="
							event => deleteModel(row.item, row.index, event)
						"
						type="button"
						size="sm"
						class="mr-1"
						variant="danger"
					>
						<md-icon icon="delete" />
					</b-button>
					<b-button
						v-if="$hasPermission('serviceType.delete')"
						@click="openMigrateModal(row.item.id)"
						type="button"
						size="sm"
						class="mr-1"
						variant="warning">
							<md-icon icon="info" />
					</b-button>
				</div>
			</template>
		</AjaxTable>

		<Single
			:unableEdit="unableEdit"
			:embbebedOnSupplier="embbebedOnSupplier"
			:supplierId="supplierId"
			ref="single"
			:success-callback="successCallback"
		/>
		<SingleResume v-model="showMigrateForm"  ref="single-resume" />
	</div>
</template>

<script>
import AjaxTable from "../../helpers/AjaxTable";
import Single from "./Single";
import SingleResume from './resume/Single'
import api from "../../../api.js";

export default {
	props: {
		embbebedOnSupplier: {
			type: Boolean,
			default: false
		},
		supplierId: Number
	},
	components: { Single, AjaxTable, SingleResume },
	data() {
		return {
			unableEdit: false,
			modalInfo: {
				modelId: -1,
				title: "Destino"
			},
			filters: {
				search: ""
			},
			showMigrateForm:false
		};
	},
	computed: {
		modelColumns() {
			const modelColumns = [
				{ key: "id", label: "ID" },
				{ key: "code", label: "Codigo" },
				{ key: "name", label: "Nombre" },
				{ key: "serviceType", label: "Tipo" },
				{ key: "maxPax", label: "Max personas" },
				{ key: "maxSuitecases", label: "Max maletas" },
				{ key: "serviceTypeCategory.name", label: "Categoria" },
				{ key: "status", label: "Estado" },
				{ key: "actions", label: "Acciones" }
			];
			return JSON.parse(JSON.stringify(modelColumns));
		}
	},
	created() {
		if (this.embbebedOnSupplier) {
			this.filters.config = {
				belongsTo: "supplier",
				supplierId: this.supplierId
			};
		}
	},
	methods: {
		successCallback() {
			this.$root.$emit(
						'bv::refresh::table',
						'service-types-index-list'
					);
		},
		editModel(id) {
			this.unableEdit = !this.$hasPermission("serviceType.edit");
			this.$refs["single"].loadModel(id);
		},
		newModel() {
			this.$refs["single"].loadModel(-1);
		},
		deleteModel(item) {
			this.$root.showWarning({
				okAction: (event, setLoading, close) => {
					setLoading(true);
					api(this)
						.delete(`/service-types/${item.id}`)
						.then(() => {
							this.$root.showAlert("Registro Eliminado!", {
								variant: "warning"
							});
							this.$root.auxVars.loadResourcesOpts({
								vm: this,
								resourceNames: ["serviceTypesOpts"],
								forceRefresh: true
							});
							this.successCallback();
							close();
						})
						.catch(err => {
							this.$root.handleRequestError(err);
							close();
						});
				}
			});
		},
		openMigrateModal(id){
			this.showMigrateForm = true;
			this.$refs['single-resume'].loadModel(id)
		}
	},

	mounted() {
		this.$root.auxVars.loadResourcesOpts({
			vm: this,
			resourceNames: ["serviceType"]
		});
	}
};
</script>

<style scoped>
.icon-show {
	cursor: pointer;
	color: #357af6;
}
.table-detail {
	background-color: #ebeafb;
	border-collapse: collapse;
	width: 100%;
}
.table-detail .title {
	background-color: #e5e2fb;
}
.table-detail td {
	border: 0px;
	background-color: #ebeafb;
}
.table-detail th {
	border: 0px;
}
</style>
